export default __webpack_public_path__ + "static/media/grafema_nutrana_11.1527badb.jpg";